export const mypageQueryKeys = {
  getMypage: '/v2/mypage',
  getEvents: '/v2/curator/mypage/events',
} as const;
